"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _graphql = require("graphql");

var _error = require("graphql/error");

var _language = require("graphql/language");

var PHONE_NUMBER_REGEX = new RegExp(/^\+\d{7,15}$/);

var _default = new _graphql.GraphQLScalarType({
  name: 'PhoneNumber',
  description: 'A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234.',
  serialize: function serialize(value) {
    if (typeof value !== 'string') {
      throw new TypeError("Value is not string: ".concat(value));
    }

    if (!PHONE_NUMBER_REGEX.test(value)) {
      throw new TypeError("Value is not a valid phone number of the form +17895551234 (7-15 digits): ".concat(value));
    }

    return value;
  },
  parseValue: function parseValue(value) {
    if (typeof value !== 'string') {
      throw new TypeError("Value is not string: ".concat(value));
    }

    if (!PHONE_NUMBER_REGEX.test(value)) {
      throw new TypeError("Value is not a valid phone number of the form +17895551234 (7-15 digits): ".concat(value));
    }

    return value;
  },
  parseLiteral: function parseLiteral(ast) {
    if (ast.kind !== _language.Kind.STRING) {
      throw new _error.GraphQLError("Can only validate strings as phone numbers but got a: ".concat(ast.kind));
    }

    if (!PHONE_NUMBER_REGEX.test(ast.value)) {
      throw new TypeError("Value is not a valid phone number of the form +17895551234 (7-15 digits): ".concat(ast.value));
    }

    return ast.value;
  }
});

exports["default"] = _default;